import { Text } from 'bold-ui'

import { TerritorioPinoQueryModel } from '../model-territorioMapa'
import { formatResults } from '../utils-territorioMapa'

interface MapaTerritorioFeedbackProps {
  pinosTerritorio: TerritorioPinoQueryModel
}

export function MapaTerritorioFeedback(props: Readonly<MapaTerritorioFeedbackProps>) {
  const { totalImoveisComCoordenadas, totalImoveisSemCoordenadas } = props.pinosTerritorio

  return (
    <>
      <Text variant='h4' fontWeight='bold' color='inherit'>
        Exibindo {formatResults(totalImoveisComCoordenadas)}
      </Text>
      <Text variant='h4' fontWeight='normal' color='inherit'>
        | {formatResults(totalImoveisSemCoordenadas)} sem geolocalização
      </Text>
    </>
  )
}
